import { useEffect, useState } from 'react';
import televedaLogo from './televeda-logo-white.png';
import { loadAudioEyeScript } from './audioeyeScript';

interface NavigationBarProps {
  communityName: string | null;
  communityLogo: string | null;
}

const NavigationBar = ({ communityName, communityLogo }: NavigationBarProps) => {

  const [logo, setLogo] = useState<string | null>(null);

  const setPrimaryColor = (hexCode: string) => {
    const normalized = hexCode.replace(/^#/, '').toLowerCase();
    window.localStorage.setItem('primaryColor', normalized);
    document.body.style.setProperty('--primary', `#${normalized}`);
    document.body.style.setProperty('--primary-lighter', `#${normalized}66`);
    document.body.style.setProperty('--primary-light', `#${normalized}33`);
  };

  const checkReferralId = async () => {
    let url = new URL(window.location.href);

    const code = url.searchParams.get('ref');

    if (!code) {
      setLogo(televedaLogo);
    }
  };

  useEffect(() => {
    if(communityLogo) {
      setLogo(communityLogo);
    }
  }, [communityLogo])

  useEffect(() => {
    const OLD_BRAND_PURPLES = new Set(['6c20c4', '632a77', '471958']);
    const NEW_BRAND_PURPLE = '481281';
    const primaryColor = window.localStorage.getItem('primaryColor');
    if (primaryColor) {
      const normalized = primaryColor.replace(/^#/, '').toLowerCase();
      setPrimaryColor(OLD_BRAND_PURPLES.has(normalized) ? NEW_BRAND_PURPLE : normalized);
    }

    loadAudioEyeScript();
    checkReferralId();
  },[])

  return (
    <header className='header'>
      <div className='row justify-content-center h-100'>
        <div className='col col-lg align-self-center'>
          <div className='site-logo-wrap'>
            {logo && <img src={logo} className='site-logo' alt='Televeda' />}
          </div>
        </div>
        {communityName &&
          <div className='col-auto align-self-center'>
            <h3 className='size-h3 u-color-white u-text-bold'>{communityName}</h3>
          </div>
        }
      </div>
    </header>
  );
};

export default NavigationBar
